import React, { useContext } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLBillingUtil } from 'ml-portals-util-react';

import metadata from './MLConfirmationPolicyDetailsBox.metadata.json5';
import messages from './MLConfirmationPolicyDetailsBox.messages';
import styles from './MLConfirmationPolicyDetailsBox.module.scss'

import { IntlContext } from '@jutro/legacy/locale';

function MLConfirmationPolicyDetailsBox(props) {
    const {
        changeTypeLabel,
        policyNumber,
        paymentMethod,
        endingIn,
        paymentSchedule,
        insured,
        policyAddress,
        secondaryInsured,
        effectiveDate,
        expirationDate,
        amount
    } = props;
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const {
        getDownPaymentMethodName
    } = MLBillingUtil();

    const getPaymentMethodList = () => {
        return (
            <>
                <li>{getDownPaymentMethodName(paymentMethod)}</li>
                {endingIn && 
                    <li>
                        {translator(messages.endingIn, { endingIn: endingIn})}
                    </li>
                }
            </>
        );
    }

    const getNoPolicyAdressList = () => {
        return (
            <>
                <li>{_.get(insured, 'primaryAddress.addressLine1')}</li>
                <li>{_.get(insured, 'primaryAddress.city')}, {_.get(insured, 'primaryAddress.state')} {_.get(insured, 'primaryAddress.postalCode')}</li>
            </>
        )
    }

    const getPolicyAdressList = () => {
        return (
            <>
                <li>{_.get(policyAddress, 'addressLine1')}</li>
                <li>{_.get(policyAddress, 'city')}, {_.get(policyAddress, 'state')} {_.get(policyAddress, 'postalCode')}</li>
            </>
        )
    }

    const getCurrencyString = (value) => {
        if(!value) return " - ";
        return intl.formatNumber(
            value.amount,
            {
                style: 'currency',
                currency: value.currency
            }
        );
    }

    const secondaryInsuredDisplayName = secondaryInsured?.displayName

    const overrideProps = {
        policyNumber: {
            content: translator(messages.policyNumber, {
                policyNumber: policyNumber
            })
        },
        effectiveDate: {
            content: translator(messages.effectiveDate, {
                changeType: changeTypeLabel,
                date: effectiveDate
            })
        },
        expirationDate: {
            content: translator(messages.expirationDate, {
                changeType: changeTypeLabel,
                date: expirationDate
            })
        },
        amount: {
            visible: !!amount,
            content: translator(messages.amount, {
                changeType: changeTypeLabel,
                amount: getCurrencyString(amount)
            })
        },
        paymentMethodList: {
            content: getPaymentMethodList()
        },
        paymentSchedule: {
            content: translator(messages.paymentSchedule, {
                paymentSchedule: paymentSchedule
            })
        },
        insuredDisplayName: {
            content: insured.displayName
        },
        noPolicyAddressList: {
            visible: !policyAddress,
            content: getNoPolicyAdressList()
        },
        policyAddressList: {
            visible: policyAddress,
            content: getPolicyAdressList()
        },
        secondaryInsuredInnerContainer: {
            visible: !!secondaryInsuredDisplayName
        },
        secondaryInsuredDisplayName: {
            content: secondaryInsuredDisplayName
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {}
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

export default MLConfirmationPolicyDetailsBox;